import React, { useState, useCallback, useEffect, useContext } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "rc-time-picker/assets/index.css";

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CitySuggestionsCMP from "./SubComponents/SuggetionsDrop";
import TimePickerInput from "./SubComponents/Time";
import DatePickerInput from "./SubComponents/Date";
import DroupDwonSuggetions from "../DropDownSuggetions";
import ReturnDate from "./SubComponents/ReturnDate";
import { useNavigate } from "react-router-dom";
import { SwapCityContext } from "../Context/SwapContext";
import moment from 'moment'
import toast from 'react-hot-toast';

const OutStandingSearchTab = ({ tripType }) => {
    // input for managing
    const { to_city, setTo_city, from_city, setFrom_city, swapStatus, setSwapStatus } = useContext(SwapCityContext);    

    // swap city context

    const Navigation = useNavigate();
    const [inputFields, setInputFields] = useState([{ cityInput: '', isDropdownOpen: false, cityId: '', state_id: '', state_name: '' }]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [check, setCheck] = useState(false);


    const [formData, setFormData] = useState({
        from_city: "",
        from_city_id: "",
        from_state_id: "",
        from_state_name: "",
        trip_type: tripType,
        to_city: "",
        to_city_id: "",
        to_state_id: "",
        to_state_name: "",
        pickup_date: "",
        pickup_time: '',
        drop_date: "",
        travel_routes: [],
        package: '',
        package_id: '',
        vehicle_name: "",
        vehicle_id: "",
    });

    // set the state of data
    const HandleStateData = (DataObject) => {
        for (let property in DataObject) {
            formData[property] = DataObject[property]
        }

        // save the formatted Data
        setFormData({
            ...formData
        })
    }


    // managing add input field
    const addInputField = () => {
        setInputFields([
            ...inputFields,
            {
                cityInput: "",
                isDropdownOpen: false,
                cityId: ''
            },
        ]);
    };

    // remove input field
    const removeInputFields = (index) => {
        // Remove the corresponding travel route from formData
        const updatedInputFields = [...inputFields];
        updatedInputFields.splice(index, 1);
        setInputFields(updatedInputFields);

        const updatedFormData = { ...formData };
        updatedFormData.travel_routes.splice(index, 1);
        setFormData(updatedFormData);
        // Update local storage with the new form data
        localStorage.setItem('cab_listing', JSON.stringify(updatedFormData));
    };

    const toggleDropdown = (index) => {
        setInputFields(prevState => {
            const updatedFields = [...prevState];
            updatedFields[index].isDropdownOpen = !updatedFields[index]?.isDropdownOpen;
            return updatedFields;
        });
    };

    // 
    const handleChange = (index, evnt) => {
        const { name, value } = evnt.target;
        setInputFields(prevState => {
            const updatedFields = [...prevState];
            updatedFields[index].cityInput = value;
            return updatedFields;
        });
    };


    const handleSuggestionClick = useCallback((suggestion, index) => {
        const city_name = suggestion.city_name + ', ' + suggestion.state_name;
        if(inputFields?.find((item) => item?.cityId === suggestion?._id)){
            toast.error(`${city_name} is already selected.`)
            return;
        }

        if (index === 0) {
            setTo_city(city_name);
        }
        setInputFields(prevState => {
            const updatedFields = [...prevState];
            updatedFields[index].cityInput = city_name;
            updatedFields[index].cityId = suggestion._id;
            updatedFields[index].state_id = suggestion.state_id;
            updatedFields[index].state_name = suggestion.state_name;
            return updatedFields;
        });
        const city = inputFields?.map(city => ({ cityInput: city.cityInput, cityId: city.cityId }));
        // addCityId(suggestion._id)
        HandleStateData({ travel_routes: city });
    }, [inputFields, HandleStateData]);

    const closeDropdown = (index) => {
        setInputFields((prevState) => {
            const updatedFields = [...prevState];
            updatedFields[index].isDropdownOpen = false;
            return updatedFields;
        });
    };

    // handle Cab searching  =---------------------- (Outstation)------------------------
    const CabSearchSubmit = (e) => {
        e.preventDefault();

        if (formData.from_city.length < 1) {
            toast.error("Please select a valid city")
            return;
        }

        if (formData.travel_routes.length < 1) {
            toast.error("Please select the drop route")
            return;
        }

        if (!formData.pickup_date) {
            toast.error("Please select a valid pickup date")
            return;
        }

        if (!formData.pickup_time) {
            toast.error("Please select a valid pickup time")
            return;
        }

        if (!formData.drop_date) {
            toast.error("Please Select Drop Date")
            return;
        }

        const currentMoment = moment();
        // Extract date strings for comparison in YYYY-MM-DD format
        const selectedDateStr = moment(formData.pickup_date).format('YYYY-MM-DD');
        const currentDateStr = currentMoment.format('YYYY-MM-DD');

        let selectedMoment;
        if (selectedDateStr === currentDateStr) {
            // If the selected date is today, combine the date and pickup time (e.g., "2025-03-26 5:30 PM")
            selectedMoment = moment(`${selectedDateStr} ${formData.pickup_time}`, 'YYYY-MM-DD h:mm A');
        } else {
            // For future dates, assume formData.pickup_date contains full date-time information
            selectedMoment = moment(formData.pickup_date);
        }

        const timeDifference = selectedMoment.diff(currentMoment, 'hours', true);


        localStorage.removeItem('cab_listing');
        localStorage.setItem('cab_listing', JSON.stringify(formData));
        Navigation('/cab-listing');
    };

    // render the data
    useEffect(() => {
        // Retrieve saved form data from local storage
        const savedFormData = JSON.parse(localStorage.getItem('cab_listing')) || {};
        if (savedFormData.trip_type === tripType) {
            // Set the form data state with saved values
            setFormData(savedFormData);
            // Set the input fields with saved travel routes
            const savedInputFields = savedFormData.travel_routes?.map((route) => ({
                cityInput: route.cityInput,
                cityId: route.cityId,
                isDropdownOpen: false
            }));
            setInputFields(savedInputFields);
        }
    }, [tripType]);

    const [isMobileView, setIsMobileView] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth <= 768); // Mobile view for screen width <= 768px
        };

        // Set initial state
        handleResize();

        // Add event listener for window resize
        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);



    return (
        <Form onSubmit={(e) => CabSearchSubmit(e)}>
            <div className="d-flex mb-3 justify-content-between">
                <CitySuggestionsCMP handleFormatted={HandleStateData} tripType={tripType} />
                {/* <div className="w10 btweenimg" onClick={(e) => swapCityData(e)}>
                    <img src={twoway} alt="Swap city" title="swap city" />
                </div> */}
                <div className="w40 multicty flex-wrap">
                    {inputFields?.map((data, index) => {
                        // const { fullName } = data;
                            if(isMobileView){
                                return (

                                    <Form.Group
                                    className="position-relative cityfield"
                                    controlId=""
                                    key={index}
                                >
                                    <Form.Label>Drop</Form.Label>
                                    <LocationOnIcon />
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter Drop city"
                                        onChange={(evnt) => handleChange(index, evnt)}
                                        value={data.cityInput}
                                        onFocus={(e) => toggleDropdown(index)}
                                        onBlur={(e) => setTimeout(() => closeDropdown(index), 200)}
                                    />
                                    {
                                        inputFields[index].isDropdownOpen &&
                                        <DroupDwonSuggetions TargetInput={data.cityInput || ''} trip_type={tripType} handleSuggestionClick={(suggestion) => handleSuggestionClick(suggestion, index)} />
                                    }
                                    <div className="cut-city">
                                        {index !== 0 ? (
                                            <button
                                                className="btn btn-outline-danger"
                                                type="button"
                                                onClick={(e) => removeInputFields(index)}
                                            >
                                                x
                                            </button>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                    <div className="plus">
                                        <AddOutlinedIcon onClick={addInputField} />
                                    </div>
                                   </Form.Group>

                                )
                            }

                            if(!isMobileView && index === 0){
                                return (
                                    <Form.Group
                                    className="position-relative cityfield"
                                    controlId=""
                                    key={index}
                                >
                                    <Form.Label>Drop</Form.Label>
                                    <LocationOnIcon />
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter Drop city"
                                        onChange={(evnt) => handleChange(index, evnt)}
                                        value={data.cityInput}
                                        onFocus={(e) => toggleDropdown(index)}
                                        onBlur={(e) => setTimeout(() => closeDropdown(index), 200)}
                                    />
                                    {
                                        inputFields[index].isDropdownOpen &&
                                        <DroupDwonSuggetions TargetInput={data.cityInput || ''} trip_type={tripType} handleSuggestionClick={(suggestion) => handleSuggestionClick(suggestion, index)} />
                                    }
                                    <div className="cut-city">
                                        {index !== 0 ? (
                                            <button
                                                className="btn btn-outline-danger"
                                                type="button"
                                                onClick={(e) => removeInputFields(index)}
                                            >
                                                x
                                            </button>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                    <div className="plus">
                                        <AddOutlinedIcon onClick={addInputField} />
                                    </div>
                                   </Form.Group>
                                )
                            }
                    })}
                </div>
                <DatePickerInput handleFormatted={HandleStateData} setSelectedDate={setSelectedDate} tripType={tripType} setCheck={setCheck} />
                <TimePickerInput handleFormatted={HandleStateData} tripType={tripType} selectedDateInput={selectedDate} />
                <ReturnDate handleFormatted={HandleStateData} selectedDate={selectedDate} tripType={tripType} check={check} />
            </div>
            <div className="multiCityDropDown">
                {!isMobileView && inputFields?.map((data, index) => {
                    // const { fullName } = data;
                    if (index !== 0) {
                        return (
                            <Form.Group
                                className="position-relative cityfield"
                                controlId=""
                                key={index}
                            >
                                {/* <Form.Label>Drop</Form.Label> */}
                                <LocationOnIcon />
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Drop city"
                                    onChange={(evnt) => handleChange(index, evnt)}
                                    value={data.cityInput}
                                    onFocus={(e) => toggleDropdown(index)}
                                    onBlur={(e) => setTimeout(() => closeDropdown(index), 200)}
                                />
                                {
                                    inputFields[index].isDropdownOpen &&
                                    <DroupDwonSuggetions TargetInput={data.cityInput || ''} trip_type={tripType} handleSuggestionClick={(suggestion) => handleSuggestionClick(suggestion, index)} />
                                }
                                <div className="cut-city">
                                    {index !== 0 ? (
                                        <button
                                            className="btn btn-outline-danger"
                                            type="button"
                                            onClick={(e) => removeInputFields(index)}
                                        >
                                            x
                                        </button>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </Form.Group>
                        );
                    }
                })}

            </div>
            <div className="softwbtn text-center">
                <Button variant="primary" type="submit">
                    Search Cab <img
                        src="/images/search.png"
                        alt="Search Icon"
                        title="Search"
                        loading="lazy"
                        width={20} height={20}
                        style={{ width: "revert-layer", height: "auto" }}
                    />
                </Button>
            </div>

        </Form>
    )
}


export default OutStandingSearchTab